import { toast } from 'react-toastify';

/**
 * Show an error toast for genuine failures, but stay SILENT for permission
 * errors (401/403). Those happen when a role lacks a feature and are already
 * communicated by the page's empty state — toasting them (once per background
 * request) just floods the screen with "You do not have permission" messages.
 *
 * Use this for background / on-mount data loads. For explicit user actions
 * (clicking Save/Delete) a normal toast is fine since it fires at most once.
 */
export const notifyApiError = (error, fallbackMessage = 'Something went wrong') => {
  if (error?.isPermissionError || error?.status === 401 || error?.status === 403) {
    return;
  }
  toast.error(error?.message || fallbackMessage);
};
